import { render, staticRenderFns } from "./ParcelaTabContent.vue?vue&type=template&id=1cadd29e&scoped=true"
import script from "./ParcelaTabContent.vue?vue&type=script&lang=js"
export * from "./ParcelaTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cadd29e",
  null
  
)

export default component.exports